import { useController, Control } from "react-hook-form";
import {
  RadioButtonGroup,
  RadioButtonGroupProps
} from "../input/components/radio-button-group";

type Props = {
  name: string;
  label?: string;
  options: Array<{ label: string; value: string | number }>;
  control?: Control; // optional when used from provider
  RadioButtonGroupProps?: Partial<RadioButtonGroupProps>;
};

export function RadioButtonGroupController(props: Props) {
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control
  });

  const helperText = fieldState.error?.message || props.RadioButtonGroupProps?.helperText;

  return (
    <RadioButtonGroup
      {...field}
      label={props.label}
      error={fieldState.invalid}
      helperText={helperText}
      options={props.options}
      {...props.RadioButtonGroupProps}
    />
  );
}
